import { Check, X, Eye } from 'lucide-react';

import { DashboardLayout } from '@/components/dashboard/DashboardLayout';
import { PageHeader } from '@/components/dashboard/PageHeader';
import { StatusBadge } from '@/components/dashboard/StatusBadge';
import { Button } from '@/components/ui/button';
import { campaigns, gameLabels } from '@/lib/mockData';

const AdminModeration = () => {
  const queue = campaigns
    .filter(c => c.status === 'review' || c.status === 'draft')
    .concat(campaigns.filter(c => c.status === 'scheduled').slice(0, 1));
  return (
    <DashboardLayout
      role="admin"
      user={{ name: 'Équipe Winkô', subtitle: 'Super Admin', initials: 'WK' }}
    >
      <PageHeader
        title="Modération"
        subtitle="Campagnes en attente de validation avant publication."
      />
      <div className="grid gap-4">
        {queue.map(c => (
          <article key={c.id} className="rounded-2xl border border-border bg-card p-5 shadow-soft">
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div>
                <h3 className="font-display text-lg font-bold">{c.name}</h3>
                <p className="text-sm text-muted-foreground">
                  {c.brand} • {c.city} • {gameLabels[c.game]}
                </p>
                <p className="mt-2 text-xs text-muted-foreground">
                  Période : {c.startDate} → {c.endDate} • {c.totalPrizes} lots
                </p>
              </div>
              <StatusBadge status={c.status} />
            </div>
            <div className="mt-4 flex flex-wrap gap-2">
              <Button variant="outline" size="sm">
                <Eye className="size-4" />
                Prévisualiser
              </Button>
              <Button size="sm" className="shadow-cta">
                <Check className="size-4" />
                Approuver
              </Button>
              <Button variant="outline" size="sm">
                <X className="size-4" />
                Refuser
              </Button>
            </div>
          </article>
        ))}
      </div>
    </DashboardLayout>
  );
};

export default AdminModeration;
